// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Wb4wqxMDwThuKiEd6V37>*{margin-right:.3rem}.Wb4wqxMDwThuKiEd6V37>*:not(:first-child){margin-left:.3rem}", "",{"version":3,"sources":["webpack://./breadcrumb.scss"],"names":[],"mappings":"AACA,wBACE,kBAAA,CAGF,0CACE,iBAAA","sourcesContent":["// Breadcrumb\n.breadcrumb > * {\n  margin-right: 0.3rem;\n}\n\n.breadcrumb > *:not(:first-child) {\n  margin-left: 0.3rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"breadcrumb": "Wb4wqxMDwThuKiEd6V37"
};
module.exports = ___CSS_LOADER_EXPORT___;
